import { defineComponent as _defineComponent } from 'vue'
import Action from '@/components/atoms/action/Action.vue';
import Badge from '@/components/atoms/badge/Badge.vue';
import InputGroup from '@/components/molecules/input/InputGroup.vue';
import { ISortConfig } from '@/components/molecules/table/header/types';
import FilterIcon from '@/icons/FilterIcon.vue';
import SearchIcon from '@/icons/SearchIcon.vue';
import TrashIcon from '@/icons/TrashIcon.vue';
import { computed, ref } from 'vue';
import FilterSelectField from './FilterSelectField.vue';
import FilterTextField from './FilterTextField.vue';
import { AppliedFilter, IFilterField, MainSearcherConfig } from './types';

export interface FiltersProps {
    title?: string;
    fields: IFilterField[];
    mainSearcher?: string | null;
    filters: Record<string, any>;
    isLoading?: boolean;
    search: (page?: number, sort?: ISortConfig) => void;
    updateFilters: (updatedFilters: Record<string, any>) => void;
    clearFilters: () => void;
    currentSort?: ISortConfig;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Filters',
  props: {
    title: { default: 'Filtros' },
    fields: null,
    mainSearcher: null,
    filters: null,
    isLoading: { type: Boolean, default: false },
    search: null,
    updateFilters: null,
    clearFilters: null,
    currentSort: { default: () => ({ col: '', dir: 'asc' }) }
  },
  setup(__props: any) {

const props = __props as { title: string, fields: IFilterField[], mainSearcher?: string | null, filters: Record<string, any>, isLoading: boolean, search: (page?: number, sort?: ISortConfig) => void, updateFilters: (updatedFilters: Record<string, any>) => void, clearFilters: () => void, currentSort: ISortConfig };



const computedMainSearcher = computed<MainSearcherConfig | null>(() => {
    if (!props.mainSearcher) return null;

    const field = props.fields.find(f => f.key === props.mainSearcher);
    if (!field) return null;

    return {
        fieldKey: field.key,
        placeholder: field.placeholder || field.label,
    };
});

const showAdvancedFilters = ref(false);

const toggleFilters = () => {
    showAdvancedFilters.value = !showAdvancedFilters.value;
};

const handleUpdateFilter = (key: string, value: any) => {
    const updatedFilters = { ...props.filters, [key]: value };
    props.updateFilters(updatedFilters);
};

const handleSearch = () => {
    props.search(1, props.currentSort);
};

const handleClearFilters = () => {
    props.clearFilters();
};

const handleEnterKey = () => {
    handleSearch();
};

const getMainSearcherField = () => {
    if (!computedMainSearcher.value) return null;

    const field = props.fields.find(f => f.key === computedMainSearcher.value!.fieldKey);
    if (!field) return null;

    return {
        label: field.label,
        placeholder: computedMainSearcher.value!.placeholder || field.placeholder || field.label,
        readonly: props.isLoading,
        value: computed({
            get: () => props.filters[field.key],
            set: (value: any) => handleUpdateFilter(field.key, value),
        }),
    };
};

const getComponentForField = (field: IFilterField) => {
    switch (field.type) {
        case 'text':
            return FilterTextField;
        case 'select':
            return FilterSelectField;
        default:
            return FilterTextField;
    }
};


const appliedFilters: AppliedFilter[] = Object.entries(props.filters).map(([key, value]) => {
    const field = props.fields.find(field => field.key === key);
    if (field && field.options) {
        if (Array.isArray(field.options)) {
            const option = field.options.find(option => option.value === value);
            if (option) {
                return { label: field.label, value: option.label };
            }
        } else if (typeof field.options === 'function') {
            const options = field.options();
            const option = options.find(option => option.value === value);
            if (option) {
                return { label: field.label, value: option.label };
            }
        }
    }
    if (field && value) {
        return { label: field.label, value: String(value) };
    }
    return null;
}).filter(Boolean);


return { __sfc: true,props, computedMainSearcher, showAdvancedFilters, toggleFilters, handleUpdateFilter, handleSearch, handleClearFilters, handleEnterKey, getMainSearcherField, getComponentForField, appliedFilters, Action, Badge, InputGroup, FilterIcon, SearchIcon, TrashIcon }
}

})